<label
  *ngIf="selectedModules?.length > 0 || addNewModule"
  class="lx-label">
  Modules
  <span class="lx-validation-warning">*</span>
</label>
<div
  class="lx-body"
  [ngClass]="{ 'box-shadow': !selectedModules.length }">
  <ng-container *ngIf="selectedModules?.length > 0">
    <ng-container *ngFor="let module of selectedModules; let j = index">
      <div class="select-container">
        <ng-select
          class="select-container__device"
          name="selectedDeviceType"
          ngDefaultControl
          placeholder="Select Device Types"
          [(ngModel)]="module.hardwarePlatform ?? module.platform"
          (change)="onDeviceTypeSelected(selectedDeviceType)">
          <ng-option
            *ngFor="let device of deviceSelection"
            [value]="module.platform">
            {{ module.hardwarePlatform ?? module.platform }}
          </ng-option>
          <ng-template
            let-item="item"
            let-search="searchTerm"
            ng-label-tmp
            ng-option-tmp>
            <span *ngIf="item === 'Otto'">All Otto</span>
            <span *ngIf="item === 'LcFlex'">All LcFlex</span>
            <span *ngIf="item !== 'Otto' && item !== 'LcFlex'">{{ item }}</span>
          </ng-template>
        </ng-select>
        <module-search
          class="select-container__version-name"
          [autoClearInput]="true"
          [disableAfterSelection]="true"
          [enableDeviceTypes]="false"
          [moduleDisplayName]="module.name + ' > ' + module.version"
          [modules]="versionAndNameSelection"
          [placeHolder]="'Search Version'"
          (module)="onModuleSelected($event)"></module-search>
        <button class="remove lx-btn-small lx-btn-text">
          <i
            class="lx-icon lx-trash"
            (click)="removeModule(module)"></i>
        </button>
      </div>
      <ng-container *ngIf="showConfigurations(module)">
        <label class="configuration__label lx-label">configurations</label>
        <div
          *ngIf="!module.configuration"
          class="configuration__placeholder">
          This Module supports configuration settings.
          <br />
          If non-default settings are needed, please enter the configuration.
        </div>
        <div class="configuration__details">
          <textarea
            placeholder="Copy/Paste Configurations"
            [class.is-invalid]="!isJsonValid(module)"
            [(ngModel)]="module.configuration"
            (change)="onConfigurationUpload(module, j, $event)"></textarea>
          <div
            *ngIf="!isJsonValid(module)"
            class="invalid-feedback">
            Invalid JSON format
          </div>
        </div>
      </ng-container>
    </ng-container>
  </ng-container>
  <div
    *ngIf="addNewModule"
    class="select-container">
    <ng-select
      class="select-container__device"
      name="selectedDeviceType"
      ngDefaultControl
      placeholder="Select Device Types"
      [(ngModel)]="selectedDeviceType"
      (change)="onDeviceTypeSelected(selectedDeviceType)">
      <ng-option
        *ngFor="let device of deviceSelection"
        [value]="device.platform">
        {{ device.hardwarePlatform ?? device.platform }}
      </ng-option>
      <ng-template
        let-item="item"
        let-search="searchTerm"
        ng-label-tmp
        ng-option-tmp>
        <span *ngIf="item === 'Otto'">All Otto</span>
        <span *ngIf="item === 'LcFlex'">All LcFlex</span>
        <span *ngIf="item !== 'Otto' && item !== 'LcFlex'">{{ item }}</span>
      </ng-template>
    </ng-select>
    <module-search
      *ngIf="selectedDeviceType"
      class="select-container__version-name"
      [autoClearInput]="true"
      [enableDeviceTypes]="false"
      [moduleDisplayName]="null"
      [modules]="versionAndNameSelection"
      [placeHolder]="'Search Version'"
      (module)="onModuleSelected($event)"></module-search>
  </div>
  <div>
    <a
      class="add-module"
      (click)="addModule()">
      Add Module
    </a>
    <a
      *ngIf="shouldShowAddFirmware()"
      class="add-firmware"
      (click)="addFirmware()">
      Add Firmware
    </a>
  </div>
  <label
    *ngIf="selectedFirmwareVersions?.length > 0 || addNewFirmware"
    class="lx-label">
    Firmware
    <span class="lx-validation-warning">*</span>
  </label>
  <div
    class="lx-body"
    [ngClass]="{ 'box-shadow': !selectedFirmwareVersions?.length }">
    <ng-container *ngIf="selectedFirmwareVersions?.length > 0">
      <ng-container
        *ngFor="let firmwareVersion of selectedFirmwareVersions; let j = index">
        <div class="select-container">
          <ng-select
            class="select-container__device"
            name="selectedFirmwareDeviceType"
            ngDefaultControl
            placeholder="Select Device Types"
            [(ngModel)]="
              firmwareVersion.hardwarePlatform ?? firmwareVersion.platform
            "
            (change)="onFirmwareDeviceTypeSelected(selectedFirmwareDeviceType)">
            <ng-option
              *ngFor="let firmwareVersion of firmwareDeviceSelection"
              [value]="firmwareVersion.platform">
              {{ firmwareVersion.hardwarePlatform ?? firmwareVersion.platform }}
            </ng-option>
            <ng-template
              let-item="item"
              let-search="searchTerm"
              ng-label-tmp
              ng-option-tmp>
              <span *ngIf="item === 'Otto'">All Otto</span>
              <span *ngIf="item === 'LcFlex'">All LcFlex</span>
              <span *ngIf="item !== 'Otto' && item !== 'LcFlex'">
                {{ item }}
              </span>
            </ng-template>
          </ng-select>
          <firmware-version-search
            class="select-container__version-name"
            [displayFirmwareVersion]="
              firmwareVersion.name + ' > ' + firmwareVersion.version
            "
            [firmwareVersions]="firmwareVersionsSelection"
            [placeHolder]="'Search Version'"
            (firmwareVersion)="
              onFirmwareSelected($event)
            "></firmware-version-search>
          <button class="remove lx-btn-small lx-btn-text">
            <i
              class="lx-icon lx-trash"
              (click)="removeFirmwareVersion(firmwareVersion)"></i>
          </button>
        </div>
      </ng-container>
    </ng-container>
    <div
      *ngIf="addNewFirmware"
      class="select-container">
      <ng-select
        class="select-container__device"
        name="selectedFirmwareDeviceType"
        ngDefaultControl
        placeholder="Select Device Types"
        [(ngModel)]="selectedFirmwareDeviceType"
        (change)="onFirmwareDeviceTypeSelected(selectedFirmwareDeviceType)">
        <ng-option
          *ngFor="let firmwareVersion of firmwareDeviceSelection"
          [value]="firmwareVersion.platform">
          {{ firmwareVersion.hardwarePlatform ?? firmwareVersion.platform }}
        </ng-option>
        <ng-template
          let-item="item"
          let-search="searchTerm"
          ng-label-tmp
          ng-option-tmp>
          <span *ngIf="item === 'Otto'">All Otto</span>
          <span *ngIf="item === 'LcFlex'">All LcFlex</span>
          <span *ngIf="item !== 'Otto' && item !== 'LcFlex'">{{ item }}</span>
        </ng-template>
      </ng-select>
      <firmware-version-search
        *ngIf="selectedFirmwareDeviceType"
        class="select-container__version-name"
        [displayFirmwareVersion]="null"
        [firmwareVersions]="firmwareVersionsSelection"
        [placeHolder]="'Search Version'"
        (firmwareVersion)="
          onFirmwareSelected($event)
        "></firmware-version-search>
    </div>

    <a
      *ngIf="addNewFirmware || selectedFirmwareVersions.length > 0"
      class="add-firmware"
      (click)="addFirmware()">
      Add Firmware
    </a>
  </div>
</div>
